module.exports = __webpack_public_path__ + "img/0Q3B3332_P_T_L_Wood_MockedUp.3d5df850.jpg";